import { takeLatest } from 'redux-saga/effects';
import PrizeActions from '../actions/PrizeActions';
import PrizeApi from '../apis/PrizeApi';
import { createSaga } from "../utils/sagaUtils";

function* prize(action) {
    yield createSaga(
        action,
        PrizeApi.get,
        PrizeActions.getPrizesSuccess,
        PrizeActions.getPrizesFailed
    );
}

function* PrizeSaga() {
    yield takeLatest(PrizeActions.TYPES.GET_PRIZES, prize);
}

export default PrizeSaga;
